import axios from 'axios';
import AuthApi from '@/app/api/AuthApi';
import moment from 'moment';
import UserApi from '@/app/api/UserApi';
import BookingApi from '@/app/api/BookingApi';
import CommuneApi from '@/app/api/CommuneApi';
import CommonApi from '@/app/api/CommonApi';
import PublicTransportTicketApi from '@/app/api/PublicTransportTicketApi';
import HealthApi from "@/app/api/HealthApi";

export default {
  loadCommuneData({ commit, state }) {
    if (!state.communeSelected) {
      return;
    }
    return CommuneApi.getCommuneDetails(state.communeSelected, state.customerUUID).then(data => {
      const { benefit_data, ...info } = data;
      commit('updateCommuneInfo', info);
      commit('updateBenefits', benefit_data);
      if (document && document.title) {
        document.title = data.appName || 'WELCMpass';
      }
      return data;
    });
  },
  loadTransactions({ state }) {
    return UserApi.getUserTransactions(state.customerUUID).catch(error => {
      console.warn(error);
      return error;
    });
  },
  loadUserData({ commit, state, dispatch }, data) {
    dispatch('loadSavedPersons');

    return axios
      .get(process.env.VUE_APP_API_BASEURL + '/v2/session/' + state.customerUUID, {
        withCredentials: true,
        headers: {
          'Accept-Language': state.lang,
        },
      })
      .then(response => {
        state.userLoaded = true;
        if (response.data.loggedIn) {
          // commit('loginUser', true)
          const user = response.data.user;
          state.loggedInUser = {
            userId: user.id,
            title: user.title,
            salutation: user.gender,
            email: user.email,
            firstName: user.firstName,
            lastName: user.lastName,
            birthday: user.birthday,
          };
        }
        const communes = response.data.communes;
        commit('updateCommunes', communes);
        commit('setValidTickets', response.data.validTickets);
        commit('setFavorites', response.data.favorites);
        commit('setPreferences', response.data.preferences);
        return response;
      })
      .catch(error => {
        console.warn(error);
        return error;
      });
  },
  loadSavedPersons({ commit }) {
    UserApi.getSavedPeople().then(data => {
      const converted = data.map(p => ({ ...p, birthday: p.birthday ? moment.utc(p.birthday) : null }));
      commit('setSavedUser', converted);
    });
  },
  loadFavorites() {},
  loadPreferences() {},
  loadCommunes() {},
  locateAndSetCommune({ commit, dispatch, state }) {
    if (window.GeoLocation && window.GeoLocation.postMessage) {
      window.newLocation = (longitude, latitude) => {
        CommuneApi.findCommuneByCoordinate(longitude, latitude).then(({ communeId }) => {
          if (communeId) {
            commit('changeLocation', communeId);
            dispatch('loadCommuneData');
          }
        });
      };

      window.GeoLocation.postMessage('getLocation');
    }
  },
  acceptedCommunes({ state }) {
    if (!state.communeSelected) {
      return [];
    }
    return CommuneApi.getAcceptedCommunes(state.communeSelected);
  },
  loginUser({ commit, state, dispatch }, user) {
    state.loggedInUser = {
      userId: user.id,
      title: user.title,
      salutation: user.salutation,
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
      birthday: user.birthday,
    };
    dispatch('loadUserData');
  },
  logoutUser({ state, dispatch }) {
    state.loggedInUser = null;
    dispatch('loadUserData');
  },
  destroySessions({ state }, code) {
    return AuthApi.destroySessions(code).catch(error => console.warn(error));
  },
  loginStatus({ state }) {
    return axios
      .get(`${process.env.VUE_APP_API_BASEURL}/v2/auth/login/status`, {
        withCredentials: true,
        headers: {
          'Accept-Language': state.lang,
        },
      })
      .then(({ data }) => data.isLoggedIn);
  },
  removeFavorite({ state }, benefit) {
    return axios
      .delete(process.env.VUE_APP_API_BASEURL + '/benefit/favorite/' + benefit.id, { withCredentials: true })
      .then(response => {
        state.favorites = state.favorites.filter(fav => fav.id !== benefit.id);
      })
      .catch(error => {
        console.warn(error);
        return error;
      });
  },
  removeFavoriteAll({ state }) {
    return axios
      .delete(process.env.VUE_APP_API_BASEURL + '/benefit/favorite/0', {
        withCredentials: true,
      })
      .then(response => {
        state.favorites = [];
      })
      .catch(error => {
        console.warn(error);
        return error;
      });
  },
  addFavorite({ state }, benefit) {
    return axios
      .put(
        process.env.VUE_APP_API_BASEURL + '/benefit/favorite',
        {
          benefitId: benefit.id,
        },
        { withCredentials: true }
      )
      .then(response => {
        state.favorites.push(benefit);
      })
      .catch(error => {
        console.warn(error);
        return error;
      });
  },
  enablePreference({ state }, preference) {
    return axios
      .put(
        process.env.VUE_APP_API_BASEURL + '/benefit/preference',
        {
          preferenceId: preference.prefId,
        },
        { withCredentials: true }
      )
      .then(response => {
        state.preferences.find(p => p.prefId === preference.prefId).prefChecked = true;
      })
      .catch(error => {
        console.warn(error);
        return error;
      });
  },
  disablePreference({ state }, preference) {
    return axios
      .delete(process.env.VUE_APP_API_BASEURL + '/benefit/preference/' + preference.prefId, { withCredentials: true })
      .then(response => {
        state.preferences.find(p => p.prefId === preference.prefId).prefChecked = false;
      })
      .catch(error => {
        console.warn(error);
        return error;
      });
  },
  fetchApiInfo({ commit }) {
    CommonApi.getApiInfo().then(data => {
      commit('setApiInfo', data.version);
    });
  },
  transferTaxcard({ state }, { taxId, code }) {
    return axios
      .post(
        `${process.env.VUE_APP_API_BASEURL}/v2/taxcard/transfer`,
        { taxId, code },
        {
          withCredentials: true,
          headers: {
            'Accept-Language': state.lang,
          },
        }
      )
      .then(response => {
        if (response.status === 422) {
          const error = new Error('Validation failed');
          // @ts-ignore
          error.response = response;
          throw error;
        }
        if (response.status !== 200) {
          throw new Error('Registration failed!');
        }
        return response;
      });
  },
  userSavedPersons({ state }) {
    return UserApi.getSavedPeople().then(persons => {
      return persons.map(p => ({ ...p, birthday: p.birthday ? moment.utc(p.birthday) : null }));
    });
  },
  saveRegistrationForm({ rootState }, { signature, passportNumber, orderId }) {
    return BookingApi.sendHousingRegistrationForm(orderId, signature, passportNumber);
  },
  userQualifiedBenefits({ state }) {
    return UserApi.getIsQualifiedForBenefits(state.customerUUID, state.communeSelected);
  },
  generatePrinterCode({ state }, { transactionId, taxcardIds }) {
    return UserApi.generatePrinterCode(state.customerUUID, transactionId, taxcardIds);
  },
  generateWalletPass({ state }, { taxId, os, userId = '' }) {
    return UserApi.generateWalletPass(state.customerUUID, taxId, os, userId);
  },
  publicTransportTicket({ state }) {
    if (!state.communeSelected) throw new Error('No commune selected');

    return PublicTransportTicketApi.getTicket(state.communeSelected, state.customerUUID);
  },
  async checkAPIHealth({state}) {
    try {
      await HealthApi.check()
    } catch (e) {
      state.inMaintenanceMode = true;
    }
  }
};
